<template>
  <div class="bg-white rounded border p-3" v-if="auth.token && auth.login">
    <div class="col-12 col-md-12" style="width: 100%">
      <div class="card-header">
        <ul
          class="nav nav-tabs card-header-tabs"
          role="tablist"
          style="flex-wrap: nowrap !important"
        >
          <li class="nav-item w-50">
            <a
              class="nav-link w-100"
              @click="flagFlag('one')"
              style="width: max-content"
              role="tab"
              aria-controls="first"
              aria-selected="true"
              >در جریان</a
            >
          </li>
          <li class="nav-item w-50">
            <a
              class="nav-link w-100"
              @click="flagFlag('two')"
              style="width: max-content"
              role="tab"
              aria-controls="two"
              aria-selected="true"
              >تکمیل شده</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div
            class="tab-pane fade overflow-auto"
            :class="{ 'active show': flag.one }"
            id="one"
            role="tabpanel"
            aria-labelledby="one-tab"
          >
            <!-- <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert">شما تا این لحظه {{ convertToPersian(String(sumItems)) }} تومان در {{ convertToPersian(String(countItems)) }} فاکتور در فروش راداَپ سهیم بوده اید.</div> -->
            <table
              class="mt-2 table table-hover table-bordered table-striped"
              id="orderTable"
            >
              <thead>
                <tr>
                  <th scope="col">شماره سفارش</th>
                  <th scope="col">فروشگاه</th>
                  <th scope="col">وضعیت</th>
                  <th scope="col">تاریخ</th>
                  <th scope="col">مبلغ (تومان)</th>
                  <th scope="col">آدرس</th>
                  <th scope="col">عملیات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in preItems" :key="item.id" :data-id="item.id">
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>{{ item.supplier }}</td>
                  <td>{{ item.state }}</td>
                  <td style="min-width: 150px;">{{ item.time }}</td>
                  <td>{{ convertToPersian(String(item.price)) }}</td>
                  <td style="color: #ff515b;min-width: 200px;">{{ item.address }}</td>
                  <td
                    class="prcolor-blue retrieval pr-pointer linked text-info"
                  >
                    <router-link
                      :to="{ name: 'Track', params: { id: item.token } }"
                    >
                      پیگیری
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tab-content">
          <div
            class="tab-pane fade overflow-auto"
            :class="{ 'active show': flag.two }"
            id="two"
            role="tabpanel"
            aria-labelledby="two-tab"
          >
            <table
              class="mt-2 table table-hover table-bordered table-striped"
              id="orderTable"
            >
              <thead>
                <tr>
                  <th scope="col">شماره سفارش</th>
                  <th scope="col">فروشگاه</th>
                  <th scope="col">تاریخ</th>
                  <th scope="col">مبلغ (تومان)</th>
                  <th scope="col">آدرس</th>
                  <th scope="col">فاکتور</th>
                  <th scope="col">عملیات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id" :data-id="item.id">
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>{{ item.type }}</td>
                  <td style="min-width: 150px;">{{ item.time }}</td>
                  <td>{{ convertToPersian(String(item.price)) }}</td>
                  <td style="color: #ff515b;min-width: 200px;">{{ item.address }}</td>
                  <td class="prcolor-blue retrieval pr-pointer linked">
                    <router-link
                      :to="{ name: 'Factor', params: { id: item.pre_id } }"
                    >
                      نمایش
                    </router-link>
                  </td>
                  <td
                    class="prcolor-blue retrieval pr-pointer linked text-info"
                    @click="reOrder(item.pre_id)"
                  >
                    سفارش مجدد
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-danger" v-else>شمامجوز دسترسی به این صفحه را ندارید</div>
</template>

<script setup>
import { alertBox } from "@/composables/silverBox";
import { ref, reactive } from "@vue/reactivity";
import { convertToPersian } from "@/composables/digits";
import { useAuth } from "@/store/auth";
import { onMounted } from "vue";
let auth = useAuth();
let items = ref();
let preItems = ref();
let countItems = ref();
let countPreItems = ref();
let sumItems = ref();

let flag = reactive({
  one: true,
  two: false,
});
auth.getToken();
onMounted(() => {
  console.log('orders');
  
  getOrders();
});

async function getOrders() {
  const formdata = new FormData();
  formdata.append("token", auth.token);
  let response = await fetch(
    "https://radap.ir/Backend/api/account/order/get.php",
    {
      method: "POST",
      body: formdata,
    }
  );
  let data = await response.json();
  items.value = data.data[0];
  preItems.value = data.data[1];
  countItems.value = data.count[0];
  countPreItems.value = data.count[1];
  sumItems.value = data.sum;
}

function reOrder() {
  alertBox("این قابلیت در حال حاضر فعال نیست");
}

function flagFlag(num) {
  flag.one = false;
  flag.two = false;
  if (num == "one") {
    flag.one = true;
  } else {
    flag.two = true;
  }
}
</script>

<style scoped>
/* @import "../../../../assets/css/account.css";
table thead tr th{
  text-align: right;
} */
</style>
